import './header.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  const header = $('.header')

  function fixedHeader() {
    if ($(window).scrollTop() > 40) {
      header.addClass('fixed')
    } else {
      header.removeClass('fixed')
    }
  }

  fixedHeader()

  $(window).on('scroll', function () {
    fixedHeader()
  })

  $('.nav__item.nav__item--submenu').click(function (e) {
    const isItem = $(e.target).parents('.nav__submenu-list').length > 0
    if (!isItem) {
      let is = $(this).data('hovered')
      $(this).is(':hover')
      if ($(window).width() === 1024 && !is) {
        e.preventDefault()
        is = true
      } else {
        is = false
      }
      $(this).data('hovered', is).attr('data-hovered', is)
      setTimeout(() => {
        $(this).data('hovered', false).attr('data-hovered', false)
      }, 1000)
    }
  })

  $('.header__arrow, .hero .btn--down').click(function (e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: $('.about').offset().top - $('.header').height() }, 250)
  })
})
